import ChartAxis from './chart-axis';

export default function findAxisByName(name, axes) {
    for (var idx = 0; idx < axes.length; idx++) {
        if (axes[idx].options.name === name) {
            axes[idx].prepareUserOptions();
            return new ChartAxis(axes[idx]);
        }
    }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-react-gauges/node_modules/@progress/kendo-charts/dist/es/chart/api-elements/find-axis-by-name.js
// module id = 978
// module chunks = 29